module.exports = __webpack_public_path__ + "23d0b1fc43c341fb81c525a2a03a421c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/detsky-tabor-1-2.jpg
// module id = 1212
// module chunks = 0